import React, { useEffect, useRef, useState } from "react";
import MarketTable from "./MarketTable";
import useCompanies from "../hooks/useCompanies";
import { useNotifications } from "../hooks/notificationsContext";
import DailyRewardTab from "./DailyRewardTab";
import JackpotPanel from "./JackpotPanel";
import InboxPanel from "./InboxPanel";
import ComposeMessagePanel from "./ComposeMessagePanel";
import { getAuth } from "firebase/auth";
import "./tradingDashboard.css";

export default function CenterPanel({
  selectedCompany,
  setSelectedCompany,
  userData,
  setForexData,
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [scope, setScope] = useState("Total Market");

  const [exchangeData, setExchangeData] = useState([]);

  const [notificationsTab, setNotificationsTab] = useState("Notifications");
  const [inboxTab, setInboxTab] = useState("Inbox");
  const [userDisplayName,] = useState(null);

  const companies = useCompanies();
  const { messages } = useNotifications();
  const tabContentRef = useRef(null);

  const [composeRecipient, setComposeRecipient] = useState("");
  const [composeMessage, setComposeMessage] = useState("");
  const [replyMessage, setReplyMessage] = useState(null);

  useEffect(() => {
    if (scope === "Exchange") {
      const fetchExchange = async () => {
        try {
          const auth = getAuth();
          const user = auth.currentUser;
          if (!user) return;

          const idToken = await user.getIdToken();

          const response = await fetch('https://us-central1-stockmarket-83a73.cloudfunctions.net/getAssetsForSale', {
            headers: {
              'Authorization': `Bearer ${idToken}`
            }
          });
          const result = await response.json();
          if (result.success) {
            setExchangeData(result.assets);
          }
        } catch (err) {
          console.error("Failed to fetch exchange assets:", err);
        }
      };
      fetchExchange();
    }
  }, [scope]);

useEffect(() => {
  if (tabContentRef.current && notificationsTab === "Notifications") {
    tabContentRef.current.scrollTop = tabContentRef.current.scrollHeight;
  }
}, [messages, notificationsTab]);

const scopes = [
    "Total Market",
    "Trader Companies",
    "Non-Trader Companies",
    "Stocks",
    "Cryptocurrency",
    "Forex",
    "Benchmarks",
    "Watchlist",
    "Exchange",
  ];

  return (
    <main id="center-panel">
      <section id="market-browser" className="tabbed-panel">
        <div className="tab-navigation-container">
          <div className="nav-modules-row">
            {scopes.map((s) => (
              <div 
                key={s}
                className={`nav-module ${scope === s ? "active" : ""}`}
                onClick={() => setScope(s)}
              >
                <span className="module-label">{s}</span>
              </div>
            ))}
          </div>
        </div>
<div 
  className="tab-content" 
  style={{ 
    padding: 0, 
    position: 'relative', 
    overflow: 'hidden',
    background: '#0d1615'
  }}
>
  <MarketTable
    exchangeAssets={exchangeData}
    companies={companies}
    sortConfig={sortConfig}
    setSortConfig={setSortConfig}
    selectedCompany={selectedCompany}
    setSelectedCompany={setSelectedCompany}
    scope={scope}
    userData={userData}
  />
</div>
      </section>

<div 
  id="notifications-inbox" 
  style={{ 
    display: "flex", 
    flexWrap: "wrap", 
    gap: "10px", 
    width: "100%",
    boxSizing: "border-box"
  }}
>

  <section 
    id="notifications" 
    className="tabbed-panel terminal-border" 
    style={{ 
      flex: "1 1 350px", 
      minWidth: "300px", 
      background: "rgba(0,0,0,0.2)", 
      backdropFilter: "blur(4px)",
      display: "flex",
      flexDirection: "column",
      border: "1px solid rgba(80, 227, 194, 0.2)"
    }}
  >
    <div className="tab-navigation-container" style={{ borderBottom: "1px solid rgba(80, 227, 194, 0.2)" }}>
      <div className="nav-modules-row" style={{ padding: "4px", gap: "2px", display: "flex" }}>
        {["Notifications", "Daily Reward", "Weekly Jackpot"].map((tab) => (
          <div 
            key={tab}
            className={`nav-module ${notificationsTab === tab ? "active" : ""}`}
            style={{
              flex: 1,
              textAlign: "center",
              padding: "8px 2px",
              fontSize: "0.6rem", 
              fontFamily: "'JetBrains Mono', monospace",
              cursor: "pointer",
              background: notificationsTab === tab ? "rgba(80, 227, 194, 0.1)" : "transparent",
              color: notificationsTab === tab ? "#50e3c2" : "#444",
              border: `1px solid ${notificationsTab === tab ? "#50e3c2" : "transparent"}`,
              textTransform: "uppercase",
              whiteSpace: "nowrap",
              transition: "all 0.2s ease"
            }}
            onClick={() => setNotificationsTab(tab)}
          >
            {tab === "Weekly Jackpot" ? "JACKPOT" : tab} 
          </div>
        ))}
      </div>
    </div>

    <div 
      className="tab-content custom-scrollbar" 
      ref={tabContentRef} 
      style={{ 
        padding: "10px", 
        height: "300px", 
        overflowY: "auto",
        background: "rgba(0,0,0,0.1)" 
      }}
    >
      {notificationsTab === "Notifications" && (
        <div className="terminal-list" style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem" }}>
          {messages.length === 0 ? (
            <p style={{ color: "#333", textAlign: "center", marginTop: "20px", fontSize: "0.6rem" }}>
              NO NOTIFICATIONS FOUND
            </p>
          ) : (
            <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {messages.map((msg, idx) => {
                let clockTime = "??:??:??";
                if (msg.timestamp) {
                  const dateObj = msg.timestamp?.toDate ? msg.timestamp.toDate() : new Date(msg.timestamp);
                  if (!isNaN(dateObj)) clockTime = dateObj.toISOString().split("T")[1].split(".")[0];
                }
                return (
                  <li key={idx} style={{ 
                    padding: "8px 0", 
                    borderBottom: "1px solid rgba(80, 227, 194, 0.05)", 
                    color: msg.type === "error" ? "#ff7b72" : "#eee", 
                    display: "flex", 
                    gap: "10px",
                    alignItems: "flex-start" 
                  }}>
                    <span style={{ color: "#50e3c2", opacity: 0.5, fontSize: "0.6rem", marginTop: "2px" }}>
                      [{clockTime}]
                    </span>
                    <span style={{ lineHeight: "1.4" }}>{msg.text}</span>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      )}
      {notificationsTab === "Daily Reward" && <DailyRewardTab />}
      {notificationsTab === "Weekly Jackpot" && <JackpotPanel userData={userData} />}
    </div>
  </section>

        <section 
          id="inbox" 
          className="tabbed-panel terminal-border" 
          style={{ 
            flex: "1 1 350px", 
            minWidth: "300px",
            background: "rgba(0,0,0,0.2)", 
            backdropFilter: "blur(4px)",
            display: "flex",
            flexDirection: "column",
            maxHeight: "260px"
          }}
        >
          <div className="tab-navigation-container" style={{ borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
            <div className="nav-modules-row" style={{ padding: "2px", gap: "2px", display: "flex" }}>
              {["Inbox", "Outbox", "Compose Message"].map((tab) => (
                <div 
                  key={tab}
                  className={`nav-module ${inboxTab === tab ? "active" : ""}`}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    padding: "6px 2px",
                    fontSize: "0.6rem",
                    fontFamily: "'JetBrains Mono', monospace",
                    cursor: "pointer",
                    background: inboxTab === tab ? "rgba(80, 227, 194, 0.15)" : "transparent",
                    color: inboxTab === tab ? "#50e3c2" : "#888",
                    border: `1px solid ${inboxTab === tab ? "#50e3c2" : "transparent"}`,
                    textTransform: "uppercase",
                    whiteSpace: "nowrap"
                  }}
                  onClick={() => setInboxTab(tab)}
                >
                  {tab === "Compose Message" ? "COMPOSE" : tab}
                </div>
              ))}
            </div>
          </div>

          <div 
            className="tab-content" 
            style={{ 
              padding: "8px", 
              height: "150px",
              overflowY: "auto",
              scrollbarWidth: "thin"
            }}
          >
            {userDisplayName && (inboxTab === "Inbox" || inboxTab === "Outbox") && (
              <InboxPanel
                type={inboxTab.toLowerCase()}
                userDisplayName={userDisplayName}
                onReply={(msg) => {
                  setReplyMessage({
                    recipient: inboxTab === "Inbox" ? msg.senderDisplayName : msg.recipientDisplayName,
                    originalMessage: msg.message,
                  });
                  setInboxTab("Compose Message");
                }}
              />
            )}
            {inboxTab === "Compose Message" && (
              <div className="center-container" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                <ComposeMessagePanel
                  replyTo={replyMessage}
                  recipient={composeRecipient}
                  setRecipient={setComposeRecipient}
                  message={composeMessage}
                  setMessage={setComposeMessage}
                  onClearReply={() => setReplyMessage(null)}
                />
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
}
